import React from 'react';

const MarketingSpecialist = () => {
    return (
        <div className="position">
            <div className="position-title">Muncie Land Bank Administrator</div>
            <p>
                The ideal candidate has strong organizational and communication skills; has expertise in housing
                rehabilitation and neighborhood revitalization; is comfortable working in an entrepreneurial, start-up
                environment; and is committed to values of diversity, equity, inclusion and transparency.
            </p>

            <div className="section">
                <div className="section-header mb-3 mt-2">Essential Duties and Responsibilities</div>
                <h5>Executive Leadership:</h5>
                <ul className="position-list">
                    <li>Set organizational direction through planning, action and persistence.</li>
                    <li>Establish effective working relationships with public and private stakeholders.</li>
                    <li>Manage growth in land bank operations and staffing.</li>
                </ul>
                <h5>Office and administrative duties:</h5>
                <ul>
                    <li>Maintain the Muncie Land Bank phone and email accounts.</li>
                    <li>
                        Assist with the establishment and maintenance of online and physical documentation processes in
                        coordination with MLB Board Secretary.
                    </li>
                    <li>Assist with preparation of board meeting agenda, in coordination with MLB Board Chair.</li>
                </ul>
                <h5>Finance and Fundraising</h5>
                <ul>
                    <li>
                        Assist with preparation of financial reports, in coordination with Whitinger & Co CPA and MLB
                        Board Treasurer.
                    </li>
                    <li>
                        Lead grant writing activities, according to the MLB funding calendar and in coordination with
                        the MLB fundraising committee.
                    </li>
                    <li>
                        Establish and cultivate relationships with private granting institutions and public units of
                        government.
                    </li>
                </ul>
                <h5>Property Acquisition, Maintenance &amp; Disposition</h5>
                <ul>
                    <li>Effectively acquire, maintain and dispose of real property.</li>
                    <li>
                        Coordinate with legal advisors, county and title insurance companies to finalize agreement
                        terms; in accordance with federal, state, and local regulations.
                    </li>
                    <li>
                        Monitor progress of agreements and maintain agreement documentation to ensure fulfillment of
                        agreement terms including receipt and expenditure of funds.
                    </li>
                </ul>
            </div>

            <div className="section">
                <div className="section-header">Education and/or Experience</div>
                <p>
                    Executive professional experience and/or bachelor’s degree required in business administration,
                    community development, public administration, urban planning or another related field. Master’s
                    degree preferred. The Executive Director must possess at least three years’ experience in business,
                    non-profit operational and financial management, or related areas.
                </p>
            </div>

            <div className="section">
                <div className="section-header">Knowledge, skills, and abilities</div>
                <ul className="position-list">
                    <li>Knowledge of and commitment to equitable and transparent governance practices</li>
                    <li>Experience in project management</li>
                    <li>Exceptional people skills and community outreach experience including public speaking</li>
                    <li>Experience with distressed property maintenance and managing contractors</li>
                    <li>
                        Willingness and ability to accomplish physical labor of property maintenance: frequently moving
                        between office and distressed properties, traversing distressed properties (interior/exterior)
                        with care, moving building materials and debris weighing up to 50 pounds
                    </li>
                    <li>
                        Willingness and ability to accomplish physical labor: frequently moving between office and
                        distressed properties, traversing distressed properties (interior/exterior) with care, moving
                        building materials and debris weighing up to 50 pounds.
                    </li>
                    <li>Experience with fundraising, grant writing and grant management, and resource development.</li>
                </ul>
            </div>

            <div className="section">
                <div className="section-header">Proficiency in the use of computers for:</div>
                <ul className="position-list">
                    <li>Word processing</li>
                    <li>Excel</li>
                    <li>E-mail</li>
                    <li>Internet</li>
                </ul>
            </div>

            <div className="section">
                <div className="section-header">Travel</div>
                <p>
                    The Administrator may work remotely or in our offices in Muncie Indiana. Upon request, and with
                    adequate notification, the Administrator may be required to visit the Muncie office and properties.
                </p>
            </div>

            <div className="section">
                <div className="section-header">Reporting</div>
                <p>Reports to the Board of Directors through the Executive Committee.</p>
            </div>

            <div className="section">
                <div className="section-header">Compensation</div>
                <p>
                    Annual Salary range 35,000 – 45,000 per year, with the opportunity for growth. Health insurance
                    benefits negotiable.
                </p>
            </div>

            <div className="section">
                <div className="section-header">Application Requirements &amp; Deadline</div>
                <p>
                    Please send resume, cover letter, and contact information for three professional references no later
                    than July 1, 2021. Rolling interviews may be scheduled as soon as applications are received.
                </p>
            </div>

            <div className="section">
                <div className="section-header">Anticipated Start Date</div>
                <p>Early July 2021</p>
            </div>
        </div>
    );
};

export default MarketingSpecialist;
